import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {Account, eventerConsoleApiClient} from "../../../api-client/EventerConsoleApiClient.ts";
import {useParams} from "react-router-dom";

interface AccountsContextProps {
    accounts: undefined | Account[];
    refresh: () => Promise<void>;
}

const AccountsContext = createContext<undefined | AccountsContextProps>(undefined)

export function AccountsProvider({ children }: { children: React.ReactNode }) {
    const [accounts, setAccounts] = useState<undefined | Account[]>(undefined);

    const refresh = useCallback(async () => {
        console.log("Refreshing accounts...");
        let discoverResponse = await eventerConsoleApiClient.discover();
        console.log("Neue Accounts:", discoverResponse.accounts);
        setAccounts([...discoverResponse.accounts]); // Neue Referenz setzen
    }, [setAccounts])

    useEffect(() => {
        refresh();
    }, [refresh, setAccounts])

    return (
        <AccountsContext.Provider value={{ accounts, refresh }}>
            {children}
        </AccountsContext.Provider>
    );
}

export function useAccounts() {
    const context = useContext(AccountsContext);
    if (!context) {
        throw new Error("useAccounts must be used within an AccountsProvider")
    }
    return context;
}

export function useAccountOpt(): undefined | Account | null {
    const accountsContext = useContext(AccountsContext)
    const {accountId} = useParams()
    if (!accountsContext) {
        throw new Error("Missing: AccountsProvider")
    }
    if (accountsContext.accounts === undefined) {
        return undefined
    }
    const account = accountsContext.accounts?.find(account => account.id === accountId)
    if (account === undefined) {
        return null
    } else {
        return account
    }
}

export function useAccount(): Account {
    const accountOpt = useAccountOpt()
    if (!accountOpt) {
        const {accountId} = useParams()
        // TODO?
        throw new Error(`Invalid accountId: '${accountId}'`)
    }
    return accountOpt
}
